import React from "react";
import { BellIcon } from "./BellIcon";
import { BinIcon } from "./BinIcon";

export const iconResolver = (iconName?: string) => {
  switch (iconName) {
    case "bell":
      return <BellIcon />;
    case "bin":
      return <BinIcon />;
    default:
      return null;
  }
};
